var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { staticClass: "box-card qrcode-card" }, [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "card-title" }, [
                      _vm._v("我的供应商码"),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "qrcode-content" }, [
                  _vm.qrcodeLoading
                    ? _c("div", { staticClass: "qrcode-loading" }, [
                        _c("i", { staticClass: "el-icon-loading" }),
                        _c("p", [_vm._v("正在生成二维码...")]),
                      ])
                    : _vm.qrcodeUrl
                    ? _c(
                        "div",
                        { staticClass: "qrcode-wrap" },
                        [
                          _c("el-image", {
                            staticClass: "qrcode-img",
                            attrs: {
                              src: _vm.qrcodeUrl,
                              "preview-src-list": [_vm.qrcodeUrl],
                              fit: "contain",
                            },
                          }),
                          _c("p", { staticClass: "qrcode-hint" }, [
                            _vm._v("用户扫描此码可向您付款"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "qrcode-actions" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "small",
                                    icon: "el-icon-download",
                                  },
                                  on: { click: _vm.downloadQrcode },
                                },
                                [_vm._v(" 下载二维码 ")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "small",
                                    icon: "el-icon-refresh",
                                  },
                                  on: { click: _vm.loadQrcode },
                                },
                                [_vm._v(" 刷新 ")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "qrcode-empty" },
                        [
                          _c("i", { staticClass: "el-icon-picture-outline" }),
                          _c("p", [_vm._v("二维码加载失败")]),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.loadQrcode },
                            },
                            [_vm._v("重新加载")]
                          ),
                        ],
                        1
                      ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "card-title" }, [
                      _vm._v("付款码设置"),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.infoLoading,
                        expression: "infoLoading",
                      },
                    ],
                    staticClass: "info-content",
                  },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "form",
                        attrs: {
                          model: _vm.form,
                          rules: _vm.rules,
                          "label-width": "100px",
                          size: "small",
                        },
                      },
                      [
                        _c("el-form-item", { attrs: { label: "供应商名称" } }, [
                          _c("span", { staticClass: "info-value" }, [
                            _vm._v(
                              _vm._s(_vm.supplierInfo.supplierName || "-")
                            ),
                          ]),
                        ]),
                        _c("el-form-item", { attrs: { label: "联系人" } }, [
                          _c("span", { staticClass: "info-value" }, [
                            _vm._v(
                              _vm._s(_vm.supplierInfo.contactPerson || "-")
                            ),
                          ]),
                        ]),
                        _c("el-form-item", { attrs: { label: "联系电话" } }, [
                          _c("span", { staticClass: "info-value" }, [
                            _vm._v(
                              _vm._s(_vm.supplierInfo.contactPhone || "-")
                            ),
                          ]),
                        ]),
                        _c("el-divider"),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "付款折扣", prop: "discountRate" },
                          },
                          [
                            _c(
                              "el-input",
                              {
                                staticStyle: { width: "220px" },
                                attrs: {
                                  placeholder:
                                    "例如：0.9（9折），1.0（无折扣）",
                                },
                                model: {
                                  value: _vm.form.discountRate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "discountRate", $$v)
                                  },
                                  expression: "form.discountRate",
                                },
                              },
                              [
                                _c("template", { slot: "append" }, [
                                  _vm._v("倍率"),
                                ]),
                              ],
                              2
                            ),
                            _c("div", { staticClass: "discount-hint" }, [
                              _vm.discountText
                                ? _c("span", { staticClass: "discount-tag" }, [
                                    _vm._v(_vm._s(_vm.discountText)),
                                  ])
                                : _vm._e(),
                              _c("span", { staticClass: "hint-text" }, [
                                _vm._v("0.9=9折，0.85=8.5折，1.0或不填=无折扣"),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "small",
                                  loading: _vm.saving,
                                },
                                on: { click: _vm.saveDiscount },
                              },
                              [_vm._v(" 保存设置 ")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "small" },
                                on: { click: _vm.resetForm },
                              },
                              [_vm._v("重置")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }